import React from 'react';
import { css } from '@emotion/react';
import { colors } from '@/styles';
import { Grid } from '@material-ui/core';

import { Body2 } from '../../blocks';

const RadioLabel = ({ title, subtitle }) => {
    return (
        <Grid direction="column">
            <Grid direction="row">
                <Body2
                    css={css`
                        color: ${colors.greys[3]};
                    `}
                >
                    {title}
                </Body2>
            </Grid>
            <Grid direction="row">
                <Body2
                    css={css`
                        color: ${colors.greys[6]};
                    `}
                >
                    {subtitle}
                </Body2>
            </Grid>
        </Grid>
    );
};

export default RadioLabel;
